export default "__VITE_ASSET__6af1bba6__"